import { render } from "./EditProvider.vue?vue&type=template&id=3955fe3f&scoped=true&ts=true"
import script from "./EditProvider.vue?vue&type=script&lang=ts"
export * from "./EditProvider.vue?vue&type=script&lang=ts"

import "./EditProvider.vue?vue&type=style&index=0&id=3955fe3f&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3955fe3f"]])

export default __exports__